import { listingConfirmation } from './listingConfirmation';

export const freeListingContract = {
  listingConfirmation,
};
